// REGISTER ALL HELPER SERVICES

// HELPER SERVICES
import { DataModelHelperService } from './data-model-helper.service';
import { DateTimeHelperService } from './date-time-helper.service';
import { NgFormBuilderHelperService } from './ng-form-builder-helper.service';
import { WHDndBehaviorSubjectHelperService } from './w-h-dnd-behavior-subject-helper.service';

export const SERVICES_HELPER: any[] = [
  DataModelHelperService,
  DateTimeHelperService,
  NgFormBuilderHelperService,
  WHDndBehaviorSubjectHelperService,
];
